import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { machineryService } from '../../../services/machineryService';
import { machineryConductorService } from '../../../services/machineryConductorService';
import Toast from '../../../components/Common/Toast';

const EditConductor = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });
  const [formData, setFormData] = useState({ name: '', document: '', license: '', status: 'active' });

  useEffect(() => {
    loadConductor();
  }, [id]);

  const loadConductor = async () => {
    setLoading(true);
    try {
      const res = await machineryService.getMachineryFormData({ conductor_id: id });
      if (res.success && res.data?.conductor) {
        const c = res.data.conductor;
        setFormData({ name: c.name || '', document: c.document || '', license: c.license || '', status: c.status || 'active' });
      } else {
        setToast({ isOpen: true, message: res.message || 'Conductor no encontrado', type: 'error' });
        setTimeout(() => navigate('/machinery/conductors'), 2000);
      }
    } catch (error) {
      setToast({ isOpen: true, message: 'Error al cargar el conductor', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await machineryConductorService.updateConductor(id, formData);
      if (response.success) {
        setToast({ isOpen: true, message: 'Conductor actualizado exitosamente', type: 'success' });
        setTimeout(() => navigate('/machinery/conductors'), 1500);
      } else {
        setToast({ isOpen: true, message: response.message || 'Error al actualizar', type: 'error' });
      }
    } catch (error) {
      setToast({ isOpen: true, message: 'Error al actualizar el conductor', type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="text-center py-12">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-teal-600" />
          <p className="mt-2 text-gray-600">Cargando conductor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Editar Conductor</h1>
          <p className="text-gray-600 mt-1">Modifique los datos del conductor</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nombre *</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Documento (DNI)</label>
              <input type="text" name="document" value={formData.document} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Licencia de conducir</label>
              <input type="text" name="license" value={formData.license} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Estado</label>
              <select name="status" value={formData.status} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
                <option value="active">Activo</option>
                <option value="inactive">Inactivo</option>
              </select>
            </div>
          </div>
          <div className="mt-6 flex gap-4">
            <button type="submit" disabled={saving} className="px-6 py-2.5 bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 text-white rounded-lg font-medium transition-colors">
              {saving ? 'Guardando...' : 'Guardar cambios'}
            </button>
            <button type="button" onClick={() => navigate('/machinery/conductors')} className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors">
              Cancelar
            </button>
          </div>
        </form>
      </div>
      <Toast isOpen={toast.isOpen} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, isOpen: false })} />
    </div>
  );
};

export default EditConductor;
